import { FC, useEffect, useState, PropsWithChildren } from 'react';
import { useTranslation } from 'next-i18next';

import { DSDialog, DSHeading, DSTextarea, DSButton, DSText } from '@stihl-design-system/components';

const MAX_CHARACTERS = 1000;

interface FeedbackModalProps {
  dialogIsOpen: boolean;
  onClose: () => void;
  onSubmit: (value: string) => void;
}

export const FeedbackModal: FC<PropsWithChildren<FeedbackModalProps>> = ({ dialogIsOpen, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState<string | null>('');
  const title = t('dashboard_feedbackBanner_popup_headline'),
    description = t('dashboard_feedbackBanner_popup_subHeadline');

  useEffect(() => setValue(''), [dialogIsOpen]);

  const onClickShareFeedback = () => {
    value ? onSubmit(value) : setValue(null);
  };

  return (
    <DSDialog
      isOpen={dialogIsOpen}
      onClose={onClose}
      data-testid="feedback-modal"
      className="max-w-xl"
      header={<DSHeading tag="h3">{title}</DSHeading>}
      footer={
        <DSButton onClick={onClickShareFeedback} data-testid="feedback-sent-btn">
          {t('dashboard_feedbackBanner_popup_button_share')}
        </DSButton>
      }
    >
      <DSText>{description}</DSText>
      <DSTextarea
        id="feedback-dialog"
        label={t('dashboard_feedbackBanner_popup_subHeadline')}
        hideLabel
        className="mt-6 h-64 w-full stihl-text-body-default-reg"
        wrapperClassName="w-full"
        maxLength={MAX_CHARACTERS}
        value={value ?? ''}
        onChange={(e) => setValue((e.target as HTMLTextAreaElement).value)}
        invalid={value === null}
        systemFeedback={t('dashboard_feedbackBanner_popup_error')}
      />
    </DSDialog>
  );
};
